import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
export function Memoize(args) {
  var hashFunction;
  var duration;
  var tags;
  if (typeof args === 'object') {
    hashFunction = args.hashFunction;
    duration = args.expiring;
    tags = args.tags;
  } else {
    hashFunction = args;
  }
  return function (target, propertyKey, descriptor) {
    if (descriptor.value != null) {
      descriptor.value = getNewFunction(descriptor.value, hashFunction, duration, tags);
    } else if (descriptor.get != null) {
      descriptor.get = getNewFunction(descriptor.get, hashFunction, duration, tags);
    } else {
      throw 'Only put a Memoize() decorator on a method or get accessor.';
    }
  };
}
export function MemoizeExpiring(expiring, hashFunction) {
  return Memoize({
    expiring: expiring,
    hashFunction: hashFunction
  });
}
var clearCacheTagsMap = new Map();
export function clear(tags) {
  var cleared = new Set();
  var _iterator = _createForOfIteratorHelper(tags),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tag = _step.value;
      var maps = clearCacheTagsMap.get(tag);
      if (maps) {
        var _iterator2 = _createForOfIteratorHelper(maps),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var mp = _step2.value;
            if (!cleared.has(mp)) {
              mp.clear();
              cleared.add(mp);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return cleared.size;
}
function getNewFunction(originalMethod, hashFunction) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var tags = arguments.length > 3 ? arguments[3] : undefined;
  var propMapName = Symbol("__memoized_map__");
  return function () {
    var returnedValue;
    if (!this.hasOwnProperty(propMapName)) {
      Object.defineProperty(this, propMapName, {
        configurable: false,
        enumerable: false,
        writable: false,
        value: new Map()
      });
    }
    var myMap = this[propMapName];
    if (Array.isArray(tags)) {
      var _iterator3 = _createForOfIteratorHelper(tags),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tag = _step3.value;
          if (clearCacheTagsMap.has(tag)) {
            clearCacheTagsMap.get(tag).push(myMap);
          } else {
            clearCacheTagsMap.set(tag, [myMap]);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (hashFunction || args.length > 0 || duration > 0) {
      var hashKey;
      if (hashFunction === true) {
        hashKey = args.map(function (a) {
          return a.toString();
        }).join('!');
      } else if (hashFunction) {
        hashKey = hashFunction.apply(this, args);
      } else {
        hashKey = args[0];
      }
      var timestampKey = "".concat(hashKey, "__timestamp");
      var isExpired = false;
      if (duration > 0) {
        if (!myMap.has(timestampKey)) {
          isExpired = true;
        } else {
          var timestamp = myMap.get(timestampKey);
          isExpired = Date.now() - timestamp > duration;
        }
      }
      if (myMap.has(hashKey) && !isExpired) {
        returnedValue = myMap.get(hashKey);
      } else {
        returnedValue = originalMethod.apply(this, args);
        myMap.set(hashKey, returnedValue);
        if (duration > 0) {
          myMap.set(timestampKey, Date.now());
        }
      }
    } else {
      var _hashKey = this;
      if (myMap.has(_hashKey)) {
        returnedValue = myMap.get(_hashKey);
      } else {
        returnedValue = originalMethod.apply(this, args);
        myMap.set(_hashKey, returnedValue);
      }
    }
    return returnedValue;
  };
}